import React from 'react';

export const BannerSettings = {
  dots: true,
  dotsClass: 'prizes-dots',
  infinite: true,
  speed: 6000,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  arrows: false,
  autoplay: true,
  customPaging: (i: number) => (
    <div
      // style={{
      //   position: 'absolute',
      //   width: '100%',
      //   top: '-6px',
      //   opacity: '0',
      // }}
      className="dg_testimonial-settings"
    >
      {i + 1}
    </div>
  ),
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 2,
        dots: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
      },
    },
  ],
};
